// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	PipeIcon: 'pipe-icon',
	LawyerInitialsSpan: 'lawyer-initials-span',
	ClerkInitialsSpan: 'clerk-initials-span',
} as const;
